import * as React from "react"
import styled from 'styled-components'
import DoubleQuoteSvgL from '../../../images/svg/double-quotes-l.svg'

const StyledContainer = styled("div")`
.card {
  border-radius: .7rem;
  border-color: #fff;
  padding: 0px 30px;
}
.vs{
  color: #f8b566;
}
  
.testimonial-quote {
  position: relative;
  text-align: left;
}

.testimonials-double_quotes {
  height: 25px;
  width: 25px; 
}

.left-quote {
  position: absolute;
  top: -10px;
  left: -24px;
}

.cls{
  color: #000;
  background-color: #f3f2f2
}
p{
  font-size: 15px;
  color: #334a4a ;
  letter-spacing: 0.2px;
  font-weight: 400;
}

.highlighter {
  display: inline-block;
  text-decoration: none;
  color: #18272f;
  font-weight: 700;
  position: relative;
}

.testimonial-card {
min-height: 100%!important;
}

`

const TestimonialsPricing = () => {
  return (
    <StyledContainer className="container">
      <div className="row d-flex justify-content-center">
        <div className="col-md-10 col-xl-8 text-center">
          <h2 className="fw-bold" style={{ position: "relative", display: "inline-block" }}>
            WHAT CLIENT SAYS
          </h2>
          <p className="mb-4 fs-6">
            Your Success, Our Proof.
          </p>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-4 mb-4 mb-md-0">
          <div className="card testimonial-card">
            <div className="card-body mt-2">
              <div className="d-flex justify-content-center mb-4">
                <img
                  loading="lazy"
                  alt="img1"
                  src="https://clearout.io/wp-content/uploads/2018/01/hayk-headshot-150x150.jpg"
                  className="rounded-circle shadow-1-strong"
                  width="100"
                  height="100"
                />
              </div>
              <p className="fw-bold mb-1">Hayk Saakian</p>
              <p>Logic Inbound, Co-founder</p>
              <p className="testimonial-quote">
                <DoubleQuoteSvgL className="testimonials-double_quotes left-quote" />
                After trying Clearout, I almost never see any bounces or failed deliveries and our open rate is as high as 82%
                sometimes because the quality of our list is good now. The
                <span className="fw-bold"> guaranteed deliverables features </span>
                gives us a lot of confidence in Clearout as a product.
              </p>

            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4 mb-md-0">
          <div className="card testimonial-card">
            <div className="card-body mt-2">
              <div className="d-flex justify-content-center mb-4">
                <img
                  loading="lazy"
                  alt="img2"
                  src="https://clearout.io/wp-content/uploads/2018/01/Headshot-2-150x150.jpg"
                  className="rounded-circle shadow-1-strong"
                  width="100"
                  height="100"
                />
              </div>
              <p className="fw-bold mb-1">Deepak Shukla</p>
              <p>Pearl Lemon, Founder & CEO</p>
              <p className="testimonial-quote">
                <DoubleQuoteSvgL className="testimonials-double_quotes left-quote" />
                We as a lead generation agency were looking for a provider that could
                help us clean emails at scale. Clearout has proven to be an excellent
                resource to help us with that journey. Increasing our deliverability
                by 23%, it's<span className="fw-bold">&nbsp;now part of our go-to tool.</span>
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-0">
          <div className="card testimonial-card">
            <div className="card-body mt-2">
              <div className="d-flex justify-content-center mb-4">
                <img
                  loading="lazy"
                  alt="img3"
                  src="https://clearout.io/wp-content/uploads/2020/03/paul-main-150x150.jpeg"
                  className="rounded-circle shadow-1-strong"
                  width="100"
                  height="100"
                />
              </div>
              <p className="fw-bold mb-1">Paul Mendoza</p>
              <p>SigParser, Co-founder</p>
              <p className="testimonial-quote">
                <DoubleQuoteSvgL className="testimonials-double_quotes left-quote" />
                It works amazingly well at validating email addresses with great API
                and support. It was able to identify about 10% of the invalid contacts
                in our database. There are other products for email verification but
                Clearout by far has the<span className="fw-bold">&nbsp;best price and easiest to use.</span>
              </p>

            </div>
          </div>
        </div>
      </div>

    </StyledContainer>
  )
}

export default TestimonialsPricing;